import { AnimatePresence, motion } from 'motion/react'
import Image from 'next/image'
import { cn } from '@/src/utils/styles'

export const AnimatedWalletLogo = ({
  logoUrl,
  displayName,
  size = 100,
  className,
}: {
  logoUrl: string
  /** Used as animation key. Must be stable to animate properly. */
  displayName: string
  size?: number
  className?: string
}) => {
  return (
    <AnimatePresence mode='wait'>
      <motion.div
        key={displayName}
        layoutId={displayName}
        layout
        transition={{
          duration: 0.4,
          type: 'spring',
          stiffness: 300,
          damping: 30,
        }}
        className={cn(className, 'z-40')}
      >
        <Image
          src={logoUrl}
          className='rounded-xl'
          alt={`${displayName} logo`}
          width={size}
          height={size}
          unoptimized
        />
      </motion.div>
    </AnimatePresence>
  )
}
